<template>

  <div class="wrapper">

    <div class="size__content__default pos__content__center">
      <!-- <form class="">
        <h4 class="">
          Follow us and sign up to our newsletter
        </h4>
        <input type="email" name="" value="" placeholder="Enter your email">
        <button type="button" name="button">Submit</button>
      </form> -->

      <form action="//hatopress.us3.list-manage.com/subscribe/post?u=756f2cd045a9c075f921c09f2&amp;id=f6a7fab8aa" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
            <h4 class="">
              Follow us and sign up to our newsletter
            </h4>
          	<input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="Enter email address" required>
            <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
            <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_756f2cd045a9c075f921c09f2_f6a7fab8aa" tabindex="-1" value=""></div>
            <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button">
      </form>

      <!--End mc_embed_signup-->
    </div>

  </div>

</template>

<script>

export default {
  data () {
    return {
      cardImage: require('../assets/gift-compressed.png')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper {
  text-align: center;
  background: hsl(159, 90%, 90%);
  background: hsl(158, 81%, 70%);
  margin: 0 0;
  padding: 2rem 0 2rem;
}
.contact-form {
  /*text-align: center;*/
  padding: 2rem 1rem 2rem;
  margin: 0 auto 0;
  /*background: hsl(186, 81%, 57%);*/
}
form {
  padding-left: 1rem;
  padding-right: 1rem;
  /*max-width: 500px;*/
  display: flex;
  /*justify-content: space-between;*/
  justify-content: center;
  align-items: center;
  align-content: center;
  /*flex-direction: column;*/
}
h4,
input,
button,
.button {
  color: hsl(159, 100%, 0%);
  font-size: .8rem;
}

input, button, .button {
  vertical-align: bottom;
  display: inline-block;
  border-radius: 5px;
  outline: none;
  line-height: 1rem;
  border: 0px solid;
}
input {
  -webkit-appearance:none;
  padding: .5em 1em;
  margin: 0 0 0 1rem;
  /*width: 80%;*/
  width: 400px;
  outline: none;
  background: #f3f3f3;
}
button, .button {
  display: block;
  cursor: pointer;
  /*display: inline-block;*/
  width: 7rem;
  padding: .5em 1em;
  border-radius: 5px;
  line-height: 1rem;
  cursor: pointer;
  background: hsl(158, 81%, 57%);
}
button:hover, .button:hover {
  background: hsl(158, 81%, 77%);
}
h4 {
  display: block;
  width: 20em;
  padding: .5em 0;
  margin: 0;
  line-height: 1rem;
}

@media screen and (max-width: 768px) {
}
@media screen and (max-width: 640px) {
  .wrapper {
    padding: 1rem 1rem 4rem;
  }
  form {
    padding: 0;
    flex-direction: column;
  }
  h4, input, .button {
    line-height: 2.5;
    margin: 0 0 1rem 0;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// Newsletter.vue?4dd43494